/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Timeline_DescriptionInputs */

const id_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const ms_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const da_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const de_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const en_us2_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const es_es2_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige dos compilaciones observadas para comparar sus archivos.`)
};

const es_mx2_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige dos instantáneas observadas para comparar sus archivos.`)
};

const fil_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const fr_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const it_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const hu_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const nl_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const no_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const pl_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const pt_br2_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const pt_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const ro_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const fi_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const sv_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const vi_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const tr_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const cs_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const bg_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const ru_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите два наблюдаемых снимка, чтобы сравнить их файлы.`)
};

const uk_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const ar_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const hi_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइलों की तुलना करने के लिए देखे गए दो स्नैपशॉट चुनें।`)
};

const th_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกสแนปช็อตที่พบสองรายการเพื่อเปรียบเทียบไฟล์`)
};

const ja_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const zh_cn2_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

const zh_hant1_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇兩個觀察到的快照來比較其檔案。`)
};

const ko_builds_timeline_description = /** @type {(inputs: Builds_Timeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose two observed snapshots to compare their files.`)
};

/**
* | output |
* | --- |
* | "Choose two observed snapshots to compare their files." |
*
* @param {Builds_Timeline_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_timeline_description = /** @type {((inputs?: Builds_Timeline_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Timeline_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_timeline_description(inputs)
	if (locale === "ms") return ms_builds_timeline_description(inputs)
	if (locale === "da") return da_builds_timeline_description(inputs)
	if (locale === "de") return de_builds_timeline_description(inputs)
	if (locale === "en-US") return en_us2_builds_timeline_description(inputs)
	if (locale === "es-ES") return es_es2_builds_timeline_description(inputs)
	if (locale === "es-MX") return es_mx2_builds_timeline_description(inputs)
	if (locale === "fil") return fil_builds_timeline_description(inputs)
	if (locale === "fr") return fr_builds_timeline_description(inputs)
	if (locale === "it") return it_builds_timeline_description(inputs)
	if (locale === "hu") return hu_builds_timeline_description(inputs)
	if (locale === "nl") return nl_builds_timeline_description(inputs)
	if (locale === "no") return no_builds_timeline_description(inputs)
	if (locale === "pl") return pl_builds_timeline_description(inputs)
	if (locale === "pt-BR") return pt_br2_builds_timeline_description(inputs)
	if (locale === "pt") return pt_builds_timeline_description(inputs)
	if (locale === "ro") return ro_builds_timeline_description(inputs)
	if (locale === "fi") return fi_builds_timeline_description(inputs)
	if (locale === "sv") return sv_builds_timeline_description(inputs)
	if (locale === "vi") return vi_builds_timeline_description(inputs)
	if (locale === "tr") return tr_builds_timeline_description(inputs)
	if (locale === "cs") return cs_builds_timeline_description(inputs)
	if (locale === "bg") return bg_builds_timeline_description(inputs)
	if (locale === "ru") return ru_builds_timeline_description(inputs)
	if (locale === "uk") return uk_builds_timeline_description(inputs)
	if (locale === "ar") return ar_builds_timeline_description(inputs)
	if (locale === "hi") return hi_builds_timeline_description(inputs)
	if (locale === "th") return th_builds_timeline_description(inputs)
	if (locale === "ja") return ja_builds_timeline_description(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_timeline_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_timeline_description(inputs)
	return ko_builds_timeline_description(inputs)
});
export { builds_timeline_description as "builds.timeline.description" }